export const initialState = {
  show: false,
  title: '',
  message: '',
  color: 'success',
  messageParams: {}
};
